import { render, staticRenderFns } from "./ReturnForm.vue?vue&type=template&id=42af058c&scoped=true"
import script from "./ReturnForm.vue?vue&type=script&lang=js"
export * from "./ReturnForm.vue?vue&type=script&lang=js"
import style0 from "./ReturnForm.vue?vue&type=style&index=0&id=42af058c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42af058c",
  null
  
)

export default component.exports